export default __webpack_public_path__ + "static/media/res10.3b0add32.PNG";